<button mat-stroked-button class="fliko-stroked-button-filled" (click)="newConversation()">
  <mat-icon>question_answer</mat-icon>
  {{ 'button.newMessage' | loc }}
</button>
